import React from "react";
import PropTypes from "prop-types";
import Slider from "@mui/material/Slider";

const toMark = ({unformatted, formatted}) => ({
  value: unformatted,
  label: formatted,
});

const MScorecardBreakdown = ({metric: {value, goalValue, troubleValue}}) => {
  const marks = [toMark(goalValue), toMark(value), toMark(troubleValue)];
  return (
  <Slider
    {...{marks}}
    value={value.unformatted}
    min={marks.reduce((a, mark) => a.value > mark.value ? mark : a).value}
    max={marks.reduce((a, mark) => a.value < mark.value ? mark : a).value}
  />
  );
};

MScorecardBreakdown.propTypes = {
  metric: PropTypes.object, //Definitions of this specific score
};

export default MScorecardBreakdown;